import React, { memo } from "react";

import { SvgIcon } from "@origin-digital/ods-icons";

const IconEast = memo(() => {
  return (
    <>
      <SvgIcon
        data-id="icon-levels"
        size="small"
        viewBox="0 0 24 24"
        color="inherit"
      >
        <rect fill="none" height="24" width="24" />
        <path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z" />
      </SvgIcon>
    </>
  );
});

export { IconEast };
